import { format, isValid, parseISO } from 'date-fns';

export type DateInput = Date | string | number | null | undefined;

const parseString = (value: string): Date => {
  const iso = parseISO(value);
  return isValid(iso) ? iso : new Date(value);
};

const toDate = (value: DateInput): Date | null => {
  if (value === null || value === undefined || value === '') return null;
  const date =
    value instanceof Date
      ? value
      : typeof value === 'string'
        ? parseString(value)
        : new Date(value);
  return isValid(date) ? date : null;
};

const apply = (value: DateInput, pattern: string, fallback: string): string => {
  const date = toDate(value);
  return date ? format(date, pattern) : fallback;
};

export const FALLBACK = '—';

/** 21 Jul 2026 */
export const formatDate = (value: DateInput, fallback = FALLBACK) =>
  apply(value, 'dd MMM yyyy', fallback);

/** 21 Jul 2026, 14:30 */
export const formatDateTime = (value: DateInput, fallback = FALLBACK) =>
  apply(value, 'dd MMM yyyy, HH:mm', fallback);

/** 14:30 */
export const formatTime = (value: DateInput, fallback = FALLBACK) =>
  apply(value, 'HH:mm', fallback);

/** Tue, 21 Jul 2026 */
export const formatDateWithWeekday = (value: DateInput, fallback = FALLBACK) =>
  apply(value, 'EEE, dd MMM yyyy', fallback);

/** Tuesday, 21 July 2026 */
export const formatDateLong = (value: DateInput, fallback = FALLBACK) =>
  apply(value, 'EEEE, d MMMM yyyy', fallback);

/** 21 Jul */
export const formatDayMonth = (value: DateInput, fallback = FALLBACK) =>
  apply(value, 'dd MMM', fallback);

/** July 2026 */
export const formatMonthYear = (value: DateInput, fallback = FALLBACK) =>
  apply(value, 'MMMM yyyy', fallback);

/**
 * Calendar date for API query params and `<input type="date">` values.
 * Not for display — always yyyy-MM-dd.
 */
export const toDateInputValue = (value: DateInput) =>
  apply(value, 'yyyy-MM-dd', '');
